function ls(key) {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
function initialOf(s) {
    return s.trim().charAt(0).toUpperCase() || 'A';
}
export function operatorIdentity(pathname) {
    const inOpengater = pathname === '/opengater' || pathname.startsWith('/opengater/');
    if (inOpengater) {
        const email = ls('og_email');
        return {
            name: email ?? 'Вход не выполнен',
            role: email ? 'Opengater' : '—',
            initial: initialOf(email ?? 'O'),
        };
    }
    const panel = ls('user_name') || ls('user_email');
    if (panel)
        return { name: panel, role: 'Admin', initial: initialOf(panel) };
    // One login: signed in through Opengater only.
    const og = ls('og_email');
    if (og)
        return { name: og, role: 'Opengater', initial: initialOf(og) };
    return { name: 'Панель', role: '—', initial: initialOf('Панель') };
}
